/*=============================================== Header component ===============================================*/

import { useContext, useState, useRef } from "react"
import classNames from "classnames"
import {
    ButtonIcon,
    ThemeContext,
    Text,
    useClickOutside,
} from "tsx-library-julseb"
import type { ThemeContextProps } from "tsx-library-julseb/types"

import { ModalContext } from "context"
import type { ModalContextType } from "context"

import { Search } from "components/layouts/Search"
import { LangSelect } from "components/layouts/LangSelect"

import {
    StyledHeader,
    Logo,
    Nav,
    StyledBurger,
} from "components/layouts/Header/styles"

import { siteData } from "data"

const Header = () => {
    const { selectedTheme, toggleTheme } = useContext(
        ThemeContext
    ) as ThemeContextProps

    const { isModalOpen } = useContext(ModalContext) as ModalContextType

    const [isNavOpen, setIsNavOpen] = useState(false)
    const el = useRef<HTMLDivElement>(null)
    useClickOutside(el, () => {
        if (isNavOpen) setIsNavOpen(false)
    })

    return (
        <StyledHeader
            className={classNames({ "modal-open": isModalOpen })}
            data-theme={selectedTheme}
        >
            <Logo to="/">{siteData.name}</Logo>

            <StyledBurger
                color="white"
                isOpen={isNavOpen}
                onClick={() => setIsNavOpen(!isNavOpen)}
                width={24}
                height={16}
            />

            <Nav
                data-theme={selectedTheme}
                className={classNames({ open: isNavOpen })}
                ref={el}
            >
                <Search />

                <ButtonIcon
                    icon={selectedTheme === "dark" ? "sun" : "moon"}
                    size={24}
                    variant="transparent"
                    onClick={toggleTheme}
                    color={selectedTheme === "dark" ? "primary" : "white"}
                />

                <LangSelect />

                <Text>{siteData.version}</Text>
            </Nav>
        </StyledHeader>
    )
}

export default Header
